import * as React from 'react';
import { Store } from 'redux';
import { IndexRedirect, Route } from 'react-router';
import {
  requireAuthOnEnter,
  requireAuthOnChange,
  makeGetComponent,
} from './utils';

export const getDashboardRoute = (store: Store<RootState>) => (
  <Route
    path="dashboard"
    getComponent={makeGetComponent(
      'DashboardPage/DashboardLayout/DashboardLayout'
    )}
    onEnter={requireAuthOnEnter(store)}
    onChange={requireAuthOnChange(store)}
  >
    <IndexRedirect to="benchmark" />
    <Route
      path="benchmark"
      getComponent={makeGetComponent('DashboardPage/DashboardPageContainer')}
    />
    <Route path="folder" getComponent={makeGetComponent('FolderPage')} />
    <Route
      path="report"
      getComponent={makeGetComponent('ReportPage/ReportPageContainer')}
    />
  </Route>
);



// WEBPACK FOOTER //
// ./app/routers/DashboardRoute.tsx